module.exports = __webpack_public_path__ + "static/media/portfolio-tool.283587d2.png";